<div class="info-popover flex flex-col items-center justify-center gap-2.5">
  <span class="title">Tamaño del papel</span>
  <div class="w-100 flex flex-row items-stretch gap-2.5">
    <img src="assets/images/tooltip-info-components/pageSize/sizes.png" />
    <div class="w-100 flex flex-col gap-1.5">
      <div class="section flex flex-row gap-2.5">
        <div class="flex flex-col gap-1">
          <div class="flex flex-row items-baseline gap-1.5">
            <span class="section_title secondary">A3:</span>
            <span class="section_info">29.7x42cm</span>
          </div>
          <span class="section_subtitle">El doble de un folio normal.</span>
        </div>
      </div>
      <div class="section flex flex-row gap-2.5">
        <div class="flex flex-col gap-1">
          <div class="flex flex-row items-baseline gap-1.5">
            <span class="section_title primary">A4:</span>
            <span class="section_info">21x29.7cm</span>
          </div>
          <span class="section_subtitle">Tamaño folio normal de to´ la vida.</span>
        </div>
      </div>
      <div class="section flex flex-row gap-2.5">
        <div class="flex flex-col gap-1">
          <div class="flex flex-row items-baseline gap-1.5">
            <span class="section_title tertiary">A5:</span>
            <span class="section_info">14.8x21cm</span>
          </div>
          <span class="section_subtitle">La mitad de un folio normal.</span>
        </div>
      </div>
    </div>
  </div>
</div>
